import { render } from "./GetInTouchForm.vue?vue&type=template&id=13649f60"
import script from "./GetInTouchForm.vue?vue&type=script&lang=js"
export * from "./GetInTouchForm.vue?vue&type=script&lang=js"

import "./GetInTouchForm.vue?vue&type=style&index=0&id=13649f60&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__